module.exports = __webpack_public_path__ + "img/62ac5d0a00124f689861971dc1048e73.4987c75e.jpg";